var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitedUserSuccess"},[_c('div',{staticClass:"icon_box"},[_c('van-icon',{attrs:{"name":"passed","size":"60","color":"#07c160"}})],1),_c('p',{staticClass:"text"},[_vm._v("提交成功!")])])}
var staticRenderFns = []

export { render, staticRenderFns }